export default __webpack_public_path__ + "static/media/Flag_of_Kiribati.42921de3.svg";